export default "__VITE_ASSET__f06eb965__"